import { useEffect, useState } from "react";
import CONFIGURACIONES from "../../../util/constants";

import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Functions } from "../../../helpers/Functions";
import MantZone from "./components/MantZone";
import { useLocation, useNavigate, useOutletContext } from "react-router-dom";
import { Http } from "../../../helpers/Http";
import List from "../../global/content/List";
const MySwal = withReactContent(Swal);

const PageZone = () => {
    const navigate = useNavigate();
    const location = useLocation();
       

    const [isRenderList, setIsRenderList] = useState(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
    // const [idEdit, setIdEdit] = useState(CONFIGURACIONES.INIT.ID_EDIT);
    const [idRef, setIdRef] = useState(CONFIGURACIONES.INIT.ID_EDIT);
    const [page, setPage] = useState(CONFIGURACIONES.INIT.CURRENT_PAGE);
    const [pages, setPages] = useState(CONFIGURACIONES.INIT.CURRENT_PAGE);
    const [limit, setLimit] = useState(CONFIGURACIONES.INIT.LIMIT_PAGE);
    const [param, setParam] = useState(CONFIGURACIONES.INIT.STRING);
    const [dataList, setDataList] = useState(CONFIGURACIONES.INIT.ARRAY);
    const [endPointShow, setEndPointShow] = useState(CONFIGURACIONES.INIT.STRING);
    const [endPointUpdate, setEndPointUpdate] = useState(CONFIGURACIONES.INIT.STRING);
    const [iconActive, setIconActive] = useState(CONFIGURACIONES.INIT.STRING);

    // const [endPointDelete, setEndPointDelete] = useState(CONFIGURACIONES.INIT.STRING);
    
    const { getUser } = useOutletContext();
    const { showSpinnerLoader } = useOutletContext();
   

    const createZone = () => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)) { return; }
        setIsRenderList(CONFIGURACIONES.INIT.STATUS_FALSE);
        console.log(`${CONFIGURACIONES.SITES.ZONES}/new`);
        
        navigate(`${CONFIGURACIONES.SITES.ZONES}/new`);
    };

    const editZone = (param) => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.ACTUALIZAR)) { return; }
        setEndPointShow(param.links.find(link => link.rel === CONFIGURACIONES.REFS.SELF)?.href || null);
        setIsRenderList(CONFIGURACIONES.INIT.STATUS_FALSE);
        navigate(`/view/zones/${param.id}`);
    };

    const deleteZone = async (param) => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.ELIMINAR)) { return; }
        let endPointDelete = param.links.find(link => link.rel === CONFIGURACIONES.REFS.DELETE)?.href || null;
        // console.log('endpoint', endPointDelete); 
        await Functions().deleteElement(endPointDelete, CONFIGURACIONES.MESSAGES.SUCCESS_DELETE_OPERATION, `${CONFIGURACIONES.MESSAGES.DELETES.ZONES} <strong>${param.nombre}</strong>`,  getUser(), loadData, {})
    };

    const closeSection = () => {
        setParam(CONFIGURACIONES.INIT.STRING);
        setPage(CONFIGURACIONES.INIT.CURRENT_PAGE);
        setLimit(CONFIGURACIONES.INIT.LIMIT_PAGE);
        
        setIsRenderList(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
        navigate(`${CONFIGURACIONES.SITES.ZONES}`);
    };

    const createDataZone = async (form) => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)) { return; }
        await Functions().save(CONFIGURACIONES.ENDPOINTS.ZONAS, CONFIGURACIONES.MESSAGES.SUCCESS_OPERATION, getUser(), closeSection, form);
    };

    const updateDataZone = async (form) => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.ACTUALIZAR)) { return; }
        await Functions().update(endPointUpdate, CONFIGURACIONES.MESSAGES.SUCCESS_UPDATE_OPERATION, getUser(), closeSection, form);
    }

    const loadData = () => {
        Http().get(`${CONFIGURACIONES.ENDPOINTS.ZONAS}?param=${param}&page=${page}&limit=${limit}`).then((rpta) => {
            if (rpta.status === CONFIGURACIONES.RESPONSES.SUCCESS) {
                setDataList(rpta.data);
                setPages(rpta.pagination.pages);
            }
        });
    };

    const searchPermissions = (action) => {
        let permisoStorage = localStorage.getItem('option_id');
        let tienePermiso = CONFIGURACIONES.INIT.STATUS_FALSE
        if (permisoStorage) {
            let permiso_id = Functions().decryptData(permisoStorage);
            tienePermiso = Functions().searchPermissions(permiso_id, action, getUser().permisos);
        }
        
        return tienePermiso;       
    };

    useEffect(() => {
        const icon = localStorage.getItem('icon_active');
        if (icon) {
            const icon_decrypt = Functions().decryptData(icon);
            setIconActive(icon_decrypt);
        }
    }, []); // se ejecuta una vez al montar

    useEffect(() => {
        if (!searchPermissions(CONFIGURACIONES.ACTIONS.MOSTRAR)) { return; }
        let search = localStorage.getItem('search');
        console.log('search', search);
        
        if (!search) {
            showSpinnerLoader();
        }
        localStorage.removeItem('search');
        // loadData();
        let segments = location.pathname.split("/");
        let lastSegment = segments[segments.length - 1];
        console.log('lastSegment', lastSegment);
        
        setIsRenderList(CONFIGURACIONES.INIT.STATUS_RENDER_LIST);
        // console.log(`result: ${lastSegment === 'new' || (!isNaN(lastSegment) && lastSegment !== '')}`);
        
        if (lastSegment === 'new' || (!isNaN(lastSegment) && lastSegment !== '')) {
            setIsRenderList(CONFIGURACIONES.INIT.STATUS_FALSE);
        } else {
            loadData();
        }
    }, [location.pathname, page, param, limit])
    
    return (
        <div className="content-wrapper">
            <div className="content-body"> 
                <div className="row">
                    {isRenderList && (<div className="col-md-12 col-xs-12">
                        <div className="card">
                            <div className="card-body">
                                <List icon={iconActive} title={'Zonas'} headers={CONFIGURACIONES.TABLES.HEADERS.ZONES} data={dataList} fnCreate={createZone} fnEdit={editZone} fnDelete={deleteZone} setPage={setPage} pages={pages} page={page} 
                                    setParam={setParam} entityPagination={'zone'} setLimit={setLimit} showEdit={searchPermissions(CONFIGURACIONES.ACTIONS.ACTUALIZAR)} showDelete={searchPermissions(CONFIGURACIONES.ACTIONS.ELIMINAR)} showCreate={searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)} dataTooltipId={'create_zone'} content={'Crear Zona'} />
                            </div>
                        </div>
                    </div>)}

                    {!isRenderList && (
                        <div className="col-lg-8 col-md-12 col-xs-12">
                            <div className="card">
                                <div className="card-body">
                                    <MantZone mant={'Zona'} idEdit={idRef} closeSection={closeSection} MySwal={MySwal} idRef={idRef} 
                                        setIdRef={setIdRef} createData={createDataZone} updateData={updateDataZone} endPointShow={endPointShow} setEndPointUpdate={setEndPointUpdate} 
                                        showCreate={searchPermissions(CONFIGURACIONES.ACTIONS.CREAR)} showEdit={searchPermissions(CONFIGURACIONES.ACTIONS.ACTUALIZAR)} />
                                </div>
                            </div>
                        </div>
                    )}
                       
                </div>
            </div>
        </div>
    )
}

export default PageZone;